module.exports = __webpack_public_path__ + "img/am.d35fabce.jpg";